import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { ScreenSize } from '../../models/screen-size.enum';
import { ToggleLeftPanel } from '../../store/actions';
import { getScreenSize } from '../../store/selectors';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatToolbar, MatToolbarRow, MatButton, MatIcon, AsyncPipe],
})
export class TopbarComponent {
  private _store = inject(Store);

  isHamburgerVisible$ = this._store.select(getScreenSize).pipe(map((screenSize) => screenSize <= ScreenSize.MD));

  constructor() {}

  toggleLeftPanel() {
    this._store.dispatch(new ToggleLeftPanel());
  }
}
